<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { AppShell } from '@/components/layout';
import { useTenantStore } from '@/stores/tenantStore';
import { useFeatures } from '@/composables/useFeatures';

const route = useRoute();
const tenantStore = useTenantStore();
const { load: loadFeatures } = useFeatures();

const isAuthLayout = computed(() => route.meta.layout === 'auth');

onMounted(() => {
  // Both calls are independent and safe to fire in parallel. Feature flags
  // need to be loaded before gated UI renders, but we don't await here —
  // components that depend on them either use the reactive ref or await load()
  // themselves.
  tenantStore.fetchBranding();
  loadFeatures();
});
</script>

<template>
  <div class="app-root dark min-h-screen bg-surface-950 font-sans text-text-secondary">
    <!-- Auth pages (login, register, etc.) — no shell -->
    <RouterView v-if="isAuthLayout" />

    <!-- Authenticated pages — wrapped in AppShell -->
    <AppShell v-else>
      <RouterView />
    </AppShell>
  </div>
</template>
